<template>
  <BaseSection is-wide>
    <template #header>
      <BaseTitle
        tag="h1"
        size="xl"
        is-medium
        data-animation="fadeInBottom"
        data-animation-delay="100"
        text="Посмотрите, как&nbsp;ответили<br> другие участники курса:"
      />
<!--       <BaseButton
        class="section__button"
        data-animation="fadeIn"
        data-animation-delay="300"
        @click="showModal"
      >
        Cмотреть
        <BaseIcon name="view" class="button__icon button__icon_after" />
      </BaseButton> -->
    </template>
    <template #content>
      <div v-if="reviews.length" class="section__reviews">
        <BaseReview
          v-for="(review, i) in reviews"
          :key="`review_${i}`"
          v-bind="review"
          class="section__review"
          data-animation="fadeInBottom"
          :data-animation-delay="300 + (i * 150)"
        />
      </div>
      <BaseText
        v-else
        size="s"
        data-animation="fadeInBottom"
        data-animation-delay="300"
      >
        Отзывов пока нет
      </BaseText>
    </template>
  </BaseSection>
</template>

<script>
import { mapState } from 'vuex';
import pageMixin from '@/mixins/page';
import BaseSection from '@/components/BaseSection.vue';
import BaseTitle from '@/components/BaseTitle.vue';
import BaseText from '@/components/BaseText.vue';
// import BaseButton from '@/components/BaseButton.vue';
// import BaseIcon from '@/components/BaseIcon.vue';
import BaseReview from '@/components/BaseReview.vue';
// import BaseModal from '@/components/BaseModal.vue';

export default {
  name: 'ReviewsPage',
  mixins: [pageMixin],
  components: {
    BaseSection,
    BaseTitle,
    BaseText,
    // BaseButton,
    // BaseIcon,
    BaseReview,
    // BaseModal,
  },
  // data() {
  //   return {
  //     isModalOpen: false,
  //   };
  // },
  computed: {
    ...mapState(['reviews']),
    // isPrevButtonVisible() {
    //   return Boolean(this.$route.meta && this.$route.meta.prev);
    // },
    // isNextButtonVisible() {
    //   return Boolean(this.$route.meta && this.$route.meta.next);
    // },
    // prevButtonText() {
    //   const { prevButtonText = 'Назад' } = this.$route.meta || {};
    //   return prevButtonText;
    // },
    // nextButtonText() {
    //   const { nextButtonText = 'Далее' } = this.$route.meta || {};
    //   return nextButtonText;
    // },
    // isIntroPage() {
    //   return this.$route.path === paths.intro;
    // },
    // isFinalPage() {
    //   return this.$route.path === paths.final;
    // },
    // nextButtonText() {
    //   if (this.isFinalPage) return 'Завершить';
    //   if (this.isIntroPage) return 'Начать';
    //   return '';
    // },
  },
  // methods: {
  //   showModal() {
  //     this.isModalOpen = true;
  //   },
  //   hideModal() {
  //     this.isModalOpen = false;
  //   },
  // },
};
</script>
